import React, { useEffect, useState, useRef } from "react";
import {
  Accordion,
  Table as Tbl,
  Tabs,
  Heading,
  DateInput,
  NumberInput,
  Text,
  IconButton,
  Panel,
  SelectPicker,
  toaster,
  Message,
  DatePicker,
  Drawer,
  Carousel,
  List,
  Modal,
  Textarea,
  Tag,
} from "rsuite";
import { Button, Form, Input, Select, Card } from "antd";
import {
  getDatosPaciente,
  getExpediente,
  getListPacientes,
  savePaciente,
  saveDocumento,
  saveAuthReq,
} from "./Services/PacientesServices";
import {
  getAntecedentes,
  getDatosCitaPorIdConsulta,
  getDocsCita,
} from "./Services/ConsultasServices";
import {
  getFormaciones,
  getEntidades,
  getMunicipios,
  getNaciones,
  getReligiones,
  getRequisitos,
  getDocsEntregados,
} from "./Services/CatalogosServices";
import {
  FaArchive,
  FaBookMedical,
  FaFolder,
  FaPlusCircle,
  FaSearch,
  FaUser,
} from "react-icons/fa";

import { useReactToPrint } from "react-to-print";
import { LucideZoomIn, PrinterIcon, SearchIcon } from "lucide-react";
import Table from "react-bootstrap/Table";
import { confApp } from "../CONF_APP";
import moment from "moment/moment";
import { LayoutHome } from "./LayoutHome";


const { Column, HeaderCell, Cell } = Tbl;

export const Pacientes = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idNefro] = useState(
    JSON.parse(localStorage.getItem("auth")).nefro.idNefro,
  );
  const [idReq, setIdReq] = useState(0);
  const [nombreNefro] = useState(
    JSON.parse(localStorage.getItem("auth")).nefro.nombreNefro,
  );

  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [appConfigParams] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp,
  );

  const fileInputRef = useRef(null);
  const componentRef = useRef();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const idMedico = JSON.parse(localStorage.getItem("auth")).idMedico;
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [disabledAnteced] = useState(idMedico === 0 ? true : false);
  const [disabledDocs, setDisabledDocs] = useState(true);
  const [disabledExped] = useState(idMedico === 0 ? true : false);
  const [data, setData] = useState([]);
  const [dataExped, setDataExped] = useState([]);
  const [open, setOpen] = useState(false);
  const [tituloDrawer, setTituloDrawer] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [dataSignosEx, setdataSignosEx] = useState([]);
  const [tratamiento, setTratamiento] = useState("");
  const [indicaciones, setIndicaciones] = useState("");
  const [motivoEx, setMotivoEx] = useState("");
  const [cambioFecha, setCambioFecha] = useState(false);
  const [nuevoPac, setNuevoPac] = useState(false);
  const [modalValida, setModalValida] = useState(false);
  const [documentoAValidar, setDocumentoAValidar] = useState("");

  const [valueGpo1, setValueGpo1] = useState("");
  const [valueGpo2, setValueGpo2] = useState("");
  const [valueGpo3, setValueGpo3] = useState("");
  const [valueGpo4, setValueGpo4] = useState("");

  const [dataAnteced, setDataAnteced] = useState([]);
  const [antecedente, setAntecedente] = useState({ nombre: "", detalles: [] });
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();

  const [sortColumnExped, setSortColumnExped] = useState();
  const [sortTypeExped, setSortTypeExped] = useState();

  const [loading, setLoading] = useState(false);
  const [loadingExped, setLoadingExped] = useState(false);

  const [filtro, setFiltro] = useState("NULL");
  const [expediente, setExpediente] = useState(false);
  const [loaderDatos, setLoaderDatos] = useState(false);
  const [listReqs, setListReqs] = useState([]);
  const [listDocsEntreg, setListDocsEntreg] = useState([]);
  const [modalOpenReqs, setModalOpenReqs] = useState(false);

  const [form] = Form.useForm();
  const [formLayout] = useState("horizontal");

  // CONSTANTES DATOS DEL PACIENTE
  const nameValue = Form.useWatch("nombre", form);
  const [paciente, setPaciente] = useState("");
  const [idConsulta, setIdConsulta] = useState(0);
  const [observaCita, setObservaCita] = useState("");
  const [idPac, setIdPac] = useState(0);
  const [telefono, setTelefono] = useState("");
  const [correo, setCorreo] = useState("");
  const [domicilio, setDomicilio] = useState("");
  const [colonia, setColonia] = useState("");
  const [fecNac, setFecNac] = useState("");
  const [listaNacion, setListaNacion] = useState([]);
  const [estado, setEstado] = useState([]);
  const [municipio, setMunicipio] = useState([]);
  const [dataNivelEstud, setDataNivEstud] = useState([]);

  const [codPais, setCodPais] = useState(0);
  const [cambioCodPais, setCambioCodPais] = useState(false);
  const [cambioReligion, setCambioReligion] = useState(false);
  const [idReligion, setIdReligion] = useState(0);
  const [cambioEntidad, setCambioEntidad] = useState(false);
  const [idEntidad, setIdEntidad] = useState("00");
  const [cambioFormacion, setCambioFormacion] = useState(false);
  const [idFormacion, setIdFormacion] = useState(0);
  const [cambioMuni, setCambioMuni] = useState(false);
  const [idMuni, setIdMuni] = useState("0");

  const [listReligion, setListReligiones] = useState([]);
  const [edad, setEdad] = useState(0);

  const printerRef = React.useRef(null);

  // if(idNefro > 0){
  //   const _nefro = JSON.parse(localStorage.getItem("auth")).nefro.nombreNefro;
  //   setNomnreNefro(_nefro);
  // }

  const [listEdoCivil] = useState([
    { label: "", value: "" },
    { label: "Soltero(a)", value: "Soltero(a)" },
    { label: "Casado(a)", value: "Casado(a)" },
    { label: "Divorciado(a)", value: "Divorciado(a)" },
    { label: "Viudo(a)", value: "Viudo(a)" },
    { label: "Union Libre", value: "Union Libre" },
    { label: "Otro", value: "Otro" },
  ]);
  const [edoCivil, setEdoCivil] = useState("");
  const [listGeneros] = useState([
    { label: "", value: "" },
    { label: "Femenino", value: "Femenino" },
    { label: "Masculino", value: "Masculino" },
    { label: "Otro", value: "Otro" },
  ]);

  const [listaAnteced, setListaAnteced] = useState([
    { nombre: "", detalles: [] },
  ]);

  const [imageList, setImageList] = useState([{ doc: "", tipoDoc: "" }]);
  const [link] = useState(confApp.LINK_DOC);
  const [modalReceta, setModalReceta] = useState(false);

  // ------------------------------------------------------------ HISTORICOS DE EXPLORACION ------------------------------
  const [frecCardiacaEx, setFrecCardiacaEx] = useState("");
  const [frecRespEx, setFrecRespEx] = useState("");
  const [tempEx, setTempEx] = useState("");
  const [presionArtEx, setPresioArtEx] = useState("");
  const [pesoEx, setPesoEx] = useState("");
  const [tallaEx, setTallaEx] = useState("");
  const [imcEx, setImcEx] = useState("");
  const [saturaOxEx, setSaturaOxEx] = useState("");
  const [glicemiaCapEx, setGlicemiaCapEx] = useState("");
  const [otrosDatosExploraEx, setOtrosDatosExploraEx] = useState("");
  const [labsEstudiosEx, setLabsEstudiosEx] = useState("");
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> FIN DE VARIABLES DE EXPLORACION FISICA

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const handleSortColumnExped = (sortColumn, sortType) => {
    setLoadingExped(true);
    setTimeout(() => {
      setLoadingExped(false);
      setSortColumnExped(sortColumn);
      setSortTypeExped(sortType);
    }, 500);
  };

  const getPageMargins = (marginTop, marginRight, marginBottom, marginLeft) => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const marginTop = "55mm";
  const marginRight = "25mm";
  const marginBottom = "25mm";
  const marginLeft = "25mm";

  const handlePrint = useReactToPrint({
    documentTitle: "Receta",
    contentRef: componentRef,
    pageStyle: getPageMargins(marginTop, marginRight, marginBottom, marginLeft),
  });

  const getPacientes = async () => {
    if (!filtro) {
      await setFiltro("NULL");
    }
    const response = await getListPacientes(idNegocio, filtro);
    setData(response);
  };

  const handleClose = () => {
    setModalReceta(false);
  };

  const getListaRequisitos = async () => {
    const result = await getRequisitos(idNegocio);
    setListReqs(result);
    setDisabledDocs(true);
  };

  const getDatosCita = async (idCons) => {
    const response = await getDatosCitaPorIdConsulta(idNegocio, idCons);
    // DATOS DE EXPLORACION FISICA
    setFrecCardiacaEx(response.dataSignos.frecCardiaca);
    setFrecRespEx(response.dataSignos.frecResp);
    setTempEx(response.dataSignos.temp);
    setPresioArtEx(response.dataSignos.presionArt);
    setPesoEx(response.dataSignos.peso);
    setTallaEx(response.dataSignos.talla);
    setImcEx(response.dataSignos.imc);
    setSaturaOxEx(response.dataSignos.saturaOx);
    setGlicemiaCapEx(response.dataSignos.glicemiaCap);
    setOtrosDatosExploraEx(response.dataSignos.otrosDatosExp);
    setLabsEstudiosEx(response.dataSignos.labsEstudios);
    setdataSignosEx(response.dataExplora);
    setMotivoEx(response.motivo);
    setIdConsulta(response.idConsulta);

    await getDocsCita(response.idConsulta).then((res) => {
      let doc = [];
      res.data.forEach((element) => {
        doc.push({ doc: element.NombreDoc, tipoDoc: element.tipoDoc });
      });
      setImageList(doc);
    });
  };

  const getPaciente = async (_idPac) => {
    await getDatosPaciente(idNegocio, _idPac).then(async (response) => {
      await loadCatalogos(false).then(async (next) => {
        setNuevoPac(false);
        setIdPac(_idPac);
        setExpediente(true);

        let _fecha = response.fechaNac;
        if (_fecha !== null) {
          var _fecNac = new Date(response.fechaNac);
          _fecNac.setDate(_fecNac.getDate() + 1);
          calculaEdad(_fecNac);
          setFecNac(_fecNac);
        } else {
          setEdad(0);
          setFecNac(null);
        }

        setCambioCodPais(false);
        setCambioEntidad(false);
        setCambioMuni(false);
        setCambioReligion(false);
        setCambioFormacion(false);

        setPaciente(response.paciente);
        setCodPais(response.codPais);
        setIdEntidad(response.idEntidad);
        setIdMuni(response.idMun);
        setIdFormacion(response.idFormacion);
        setIdReligion(response.idReligion);

        form.setFieldsValue({
          paciente: response.paciente,
          fechaNac: _fecNac,
          telefono: response.telefono,
          correo: response.correo,
          calleNum: response.calleNum,
          colonia: response.colonia,
          codPostal: response.codPostal,
          idEntidad: response.idEntidad,
          idMuni: response.municipio,
          contacto1: response.contacto1,
          relacion1: response.relacion1,
          telContacto1: response.telContacto1,
          contacto2: response.contacto2,
          relacion2: response.relacion2,
          telContacto2: response.telContacto2,
          codPais: response.pais,
          edoCivil: response.edoCivil,
          genero: response.genero === null ? "" : response.genero,
          idFormacion: response.nivelEstud,
          idReligion: response.religion,
        });

        setDisabledDocs(false);

        await getDocsEntregados(idNegocio, _idPac).then((next) => {
          setListDocsEntreg(next);
        });
      });

      // const _result = getAntecedentes(idNegocio, _idPac);
      // setListaAnteced(_result);
      // getExpedientePaciente(_idPac);
    });
  };

  const cleanForm = () => {
    setDisabledDocs(true);
    setListDocsEntreg([]);
    form.resetFields();
  };

  const save = async (values) => {
    if (!nuevoPac && !cambioCodPais) {
      values.codPais = codPais;
    }
    if (!nuevoPac && !cambioEntidad) {
      values.idEntidad = idEntidad;
    }
    if (!nuevoPac && !cambioMuni) {
      values.idMuni = idMuni;
    }
    if (!nuevoPac && !cambioFormacion) {
      values.idFormacion = idFormacion;
    }
    if (!nuevoPac && !cambioReligion) {
      values.idReligion = idReligion;
    }

    const newObj = { ...values, id: idNegocio, idPaciente: idPac };

    await savePaciente(newObj).then(async (nxt) => {
      if (nxt.data > 0) {
        setPaciente(values.paciente);
        setIdPac(nxt.data);
        setDisabledDocs(false);
        toast("Los datos se han actualizado de forma correcta.", "success");
        if (nuevoPac) {
          await getDocsEntregados(idNegocio, nxt.data).then((next) => {
            setListDocsEntreg(next);
          });
        }
      }
    });
  };

  const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return data;
  };

  const getDataExped = () => {
    if (sortColumn && sortType) {
      return dataExped.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return dataExped;
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const handleChangeValueExplora = (e, idGpo) => {
    if (idGpo === 1) {
      setValueGpo1(e);
    }
    if (idGpo === 2) {
      setValueGpo2(e);
    }
    if (idGpo === 3) {
      setValueGpo3(e);
    }
    if (idGpo === 4) {
      setValueGpo4(e);
    }
  };

  const handleFechaNac = (e) => {
    var esFecha = moment(e, "DD/MM/YYYY").isValid();
    if (esFecha) {
      var fec = new Date(e).toISOString();
      var fecha = moment(fec).format("DD/MM/YYYY");
      setFecNac(fecha);

      const hoy = new Date(); // Fecha actual
      const fechaNac = new Date(e); // Fecha de nacimiento del input

      let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

      const mesActual = hoy.getMonth();
      const mesNac = fechaNac.getMonth();
      setCambioFecha(true);
      // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
      if (mesActual < mesNac) {
        edad--;
      } else if (mesActual === mesNac) {
        // Si los meses son iguales, revisamos el día
        const diaActual = hoy.getDate();
        const diaNac = fechaNac.getDate();
        if (diaActual < diaNac) {
          edad--; // No ha cumplido años aún en el mes actual
        }
      }

      // Para obtener meses y días exactos (más complejo, pero posible)
      // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
      // El método anterior solo da los años cumplidos.
      setEdad(edad);
    }
  };

  const showExpediente = async (props) => {
    const dataPaciente = {
      idPaciente: props.idPac,
    };
    localStorage.setItem("dataPaciente", JSON.stringify(dataPaciente));
    getPaciente(props.idPac);
  };

  const getFinalText = (text) => {
    const lines = text.split("\n");
    return (
      <div>
        {lines.map((item, index) => (
          <React.Fragment key={index}>
            {item}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const uploadDoc = async (e, props) => {
    const formData = new FormData();
    formData.append("id", idNegocio);
    formData.append("idPac", idPac);
    formData.append("file", e.target.files[0]);
    formData.append("idReq", props.idReq);

    await saveDocumento(formData).then(async (next) => {
      if (next.data !== "") {
        toast("El documento se ha cargado de forma correcta", "success");
        await getDocsEntregados(idNegocio, idPac).then((next) => {
          setListDocsEntreg(next);
        });
      } else {
        toast("Ocurrio un error al guardar el documento", "error");
      }
    });
  };

  const loadCatalogos = async (esNuevo) => {
    setNuevoPac(esNuevo);
    setIdPac(0);
    setPaciente("");
    cleanForm();
    setFecNac("");
    setEdad(0);
    setCambioCodPais(false);
    setCambioEntidad(false);
    setCambioMuni(false);
    setCambioReligion(false);
    setCambioFormacion(false);

    await getEntidades().then(async (nxt) => {
      setEstado(nxt);
      await getNaciones().then(async (res) => {
        setListaNacion(res);
        await getFormaciones().then(async (res) => {
          setDataNivEstud(res);
          await getReligiones().then(async (res) => {
            setListReligiones(res);
            await getListaRequisitos();
            setModalOpenReqs(esNuevo);
          });
        });
      });
    });
  };

  const handleCloseModalValida = () => {
    setModalValida(false);
  };

  const openModalValida = (props) => {
    setModalValida(true);
    setIdReq(props.idReq);
    setDocumentoAValidar(props.documento);
  };

  const loadMunicipios = async (e) => {
    setCambioEntidad(true);
    const result = await getMunicipios(e);
    setMunicipio(result);
  };

  const validateMessages = {
    required: "* Obligatorio",
    types: {
      email: "* El campo de correo no es valido",
      number: "* El campo no es un número!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };

  const saveAuthRequisito = async () => {
    const data = {
      id: idNegocio,
      idPac: idPac,
      idReq: idReq,
      idNefro: idNefro
    }

    await saveAuthReq(data).then(async (next) => {
      if(next.data > 0){
        toast('Se ha validado el documento de forma correcta.','success');
        await getDocsEntregados(idNegocio, idPac).then(next => {
          setListDocsEntreg(next);
          setModalValida(false);
        });
      }else{
        toast('Ocurrio un error al registrar la validación','error');
      }
    });

  }

  const handleCloseModalReqs = () => {
    setModalOpenReqs(false);
  };

  const getDetalles = async (props) => {
    getDatosCita(props.idC);
    setTituloDrawer(props.titulo);
    setDiagnostico(props.diagnostico);
    setTratamiento(props.tratamiento);
    setIndicaciones(props.indicaciones);
    setObservaCita(props.observa);
    setOpen(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, [imageList]);

  return (
    <>
      <LayoutHome title={"Pacientes"} selectedKey={"7"}>
        <Form layout={formLayout}>
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4">
              <Form.Item label="Filtro">
                <Input
                  name="filtro"
                  onChange={(e) => setFiltro(e)}
                  autoFocus
                  placeholder="Buscar por nombre, apellidos o teléfono..."
                />
              </Form.Item>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <Button appearance="primary" onClick={getPacientes}>
                Buscar &nbsp; <FaSearch></FaSearch>
              </Button>
              &nbsp;
              <Button appearance="primary" onClick={() => loadCatalogos(true)}>
                Nuevo &nbsp; <FaPlusCircle></FaPlusCircle>
              </Button>
            </div>
          </div>
        </Form>
        <br></br>
        <Tbl
          height={150}
          hover={true}
          showHeader={true}
          data={getData}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          loading={loading}
          bordered={true}
          cellBordered={true}
          headerHeight={30}
          rowHeight={40}
          key={`id-tbl-1`}
          id="tbl-1"
        >
          <Column width={350} resizable sortable>
            <HeaderCell>Paciente</HeaderCell>
            <Cell dataKey="paciente" />
          </Column>

          <Column width={50} fixed sortable>
            <HeaderCell></HeaderCell>
            <Cell style={{ padding: "6px" }} align="center">
              {(rowData) => (
                <Button
                  appearance="subtle"
                  size="sm"
                  title="Click para mostrar datos"
                  onClick={() =>
                    showExpediente({
                      idPac: rowData.idPaciente,
                      paciente: rowData.paciente,
                    })
                  }
                >
                  <LucideZoomIn />
                </Button>
              )}
            </Cell>
          </Column>

          <Column width={300} fixed sortable>
            <HeaderCell>Contacto (1)</HeaderCell>
            <Cell dataKey="contacto1" />
          </Column>

          <Column flexGrow={1} width={120} fixed sortable>
            <HeaderCell align="center">Tel. Contacto (1)</HeaderCell>
            <Cell dataKey="telContacto1" align="center" />
          </Column>

          <Column width={60} fixed sortable>
            <HeaderCell align="center">Sesiones</HeaderCell>
            <Cell dataKey="sessiones" align="center" />
          </Column>

          <Column width={60} fixed sortable>
            <HeaderCell align="center">Citas</HeaderCell>
            <Cell dataKey="citas" align="center" />
          </Column>

          <Column width={80} fixed sortable>
            <HeaderCell align="center">Consultas</HeaderCell>
            <Cell dataKey="consultas" align="center" />
          </Column>
        </Tbl>
        <br></br>
        {expediente || nuevoPac ? (
          <>
            <Heading level={isMobile ? 9 : 5}>Paciente: {paciente}</Heading>
            <br></br>
            <Tabs
              defaultActiveKey="1"
              bordered
              appearance={isMobile ? "subtle" : "tabs"}
              style={{ fontSize: isMobile ? "12px" : "16px" }}
            >
              {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB DATOS GENERALES */}
              <Tabs.Tab
                eventKey="1"
                title={isMobile ? <FaUser></FaUser> : "Datos Generales"}
              >
                <Card>
                  <Form
                    name="basic"
                    form={form}
                    layout="vertical"
                    variant="outlined"
                    initialValues={{ remember: true }}
                    onFinish={save}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    validateMessages={validateMessages}
                  >
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <Form.Item
                          name="paciente"
                          label={"Nombre completo"}
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </Form.Item>
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <Form.Item
                          name="fechaNac"
                          label={"Fecha de nacimiento"}
                          rules={[{ required: true }]}
                        >
                          <DateInput
                            format="dd/MM/yyyy"
                            defaultValue={fecNac}
                            onChange={(e) => handleFechaNac(e)}
                          />
                        </Form.Item>
                      </div>

                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <Form.Item label={"Edad"}>
                          <Input
                            readOnly
                            value={edad}
                            style={{ textAlign: "center" }}
                          />
                        </Form.Item>
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <Form.Item
                          name="telefono"
                          label={"Teléfono"}
                          rules={[{ required: true }]}
                        >
                          <NumberInput
                            controls={false}
                            id="telefono"
                            maxLength={10}
                            min={0}
                          />
                        </Form.Item>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4">
                        <Form.Item
                          label="Correo"
                          name={"correo"}
                          rules={[
                            {
                              type: "email",
                              message: "* No es un formato valido de correo",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <Form.Item
                          label="Calle y número"
                          name={"calleNum"}
                          rules={[{ required: true }]}
                        >
                          <Input autoComplete="off" />
                        </Form.Item>
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <Form.Item
                          label="Colonia"
                          name={"colonia"}
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </Form.Item>
                      </div>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <Form.Item
                          label="CP"
                          name={"codPostal"}
                          rules={[{ required: true }]}
                        >
                          <Input maxLength={5} />
                        </Form.Item>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <Form.Item
                          label="Estado"
                          name={"idEntidad"}
                          rules={[{ required: true }]}
                        >
                          <Select
                            options={estado}
                            onChange={(e) => loadMunicipios(e)}
                            showSearch={{
                              optionFilterProp: "label",
                              filterSort: (optionA, optionB) =>
                                (optionA?.label ?? "")
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? "").toLowerCase(),
                                  ),
                            }}
                            autoComplete="off"
                          />
                        </Form.Item>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <Form.Item
                          label="Municipio"
                          name={"idMuni"}
                          rules={[{ required: true }]}
                        >
                          <Select
                            options={municipio}
                            showSearch={{
                              optionFilterProp: "label",
                              filterSort: (optionA, optionB) =>
                                (optionA?.label ?? "")
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? "").toLowerCase(),
                                  ),
                            }}
                            onChange={() => setCambioMuni(true)}
                            autoComplete="off"
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <Form.Item
                          label="Contacto(1)"
                          name={"contacto1"}
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </Form.Item>
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <Form.Item
                          label="Parentesco (1)"
                          name={"relacion1"}
                          rules={[{ required: true }]}
                        >
                          <Select
                            style={{ width: "100%" }}
                            options={confApp.RELACIONES}
                            block
                          />
                        </Form.Item>
                      </div>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <Form.Item
                          label="Teléfono"
                          name={"telContacto1"}
                          rules={[{ required: true }]}
                        >
                          <Input maxLength={10} />
                        </Form.Item>
                      </div>

                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <Form.Item label="Contacto(2)" name={"contacto2"}>
                          <Input />
                        </Form.Item>
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <Form.Item label="Parentesco (2)" name={"relacion2"}>
                          <Select
                            style={{ width: "100%" }}
                            options={confApp.RELACIONES}
                            block
                          />
                        </Form.Item>
                      </div>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <Form.Item label="Teléfono" name={"telContacto2"}>
                          <Input maxLength={10} />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <Form.Item
                          label="Nacionalidad"
                          name={"codPais"}
                          rules={[{ required: true }]}
                        >
                          <Select
                            options={listaNacion}
                            showSearch={{
                              optionFilterProp: "label",
                              filterSort: (optionA, optionB) =>
                                (optionA?.label ?? "")
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? "").toLowerCase(),
                                  ),
                            }}
                            onChange={() => setCambioCodPais(true)}
                          />
                        </Form.Item>
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <Form.Item label="Estado Civil" name={"edoCivil"}>
                          <Select options={listEdoCivil} />
                        </Form.Item>
                      </div>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <Form.Item label="Genero" name={"genero"}>
                          <Select options={listGeneros} />
                        </Form.Item>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4">
                        <Form.Item
                          label="Formación académica"
                          name={"idFormacion"}
                          rules={[{ required: true }]}
                        >
                          <Select
                            options={dataNivelEstud}
                            showSearch={{
                              optionFilterProp: "label",
                              filterSort: (optionA, optionB) =>
                                (optionA?.label ?? "")
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? "").toLowerCase(),
                                  ),
                            }}
                            onChange={() => setCambioFormacion(true)}
                          />
                        </Form.Item>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <Form.Item
                          label="Religión"
                          name={"idReligion"}
                          rules={[{ required: true }]}
                        >
                          <Select
                            options={listReligion}
                            showSearch={{
                              optionFilterProp: "label",
                              filterSort: (optionA, optionB) =>
                                (optionA?.label ?? "")
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? "").toLowerCase(),
                                  ),
                            }}
                            onChange={() => setCambioReligion(true)}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <br></br>
                        <Button type="primary" htmlType="submit" block>
                          Guardar
                        </Button>
                      </div>
                    </div>
                  </Form>
                </Card>
              </Tabs.Tab>
              <Tabs.Tab
                eventKey="2"
                title={isMobile ? <FaArchive></FaArchive> : "Documentación"}
                disabled={disabledDocs}
              >
                <Card>
                  <div className="row mb-3">
                    <div className="col">
                      <Text weight="semibold">Lista de Documentos</Text>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <Table
                        striped
                        bordered
                        hover
                        responsive
                        key={`tbl-Docs`}
                        style={{
                          width: "100%",
                          cellPadding: "5",
                          cellSpacing: "10",
                          borderRadius: "15px",
                          fontSize: isMobile ? "10px" : "14px",
                        }}
                        cellPadding={10}
                        cellSpacing={10}
                      >
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>
                              <Text size={"sm"}>#</Text>
                            </th>
                            <th>
                              <Text size={"sm"}>Requisito</Text>
                            </th>
                            <th>
                              <Text size={"sm"}>Documento entregado</Text>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <Text size={"sm"}>Fecha Entrega</Text>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <Text size={"sm"}>Prox. Fecha</Text>
                            </th>
                            <th style={{ textAlign: "center", width: "7%" }}>
                              <Text size={"sm"}>Validado</Text>
                            </th>
                            <th>
                              <Text size={"sm"}>Subir archivo...</Text>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {listDocsEntreg.length > 0 ? (
                            listDocsEntreg.map((item, index) => {
                              return (
                                <tr key={`fila-${item.idReq}`}>
                                  <td style={{ textAlign: "center" }}>
                                    {item.idReq}
                                  </td>
                                  <td>{item.nomReq}</td>
                                  <td>
                                    <div key={index}>
                                      <a
                                        href={`Unidades/${idNegocio}/Expedientes/Pacientes/${idPac}/Documentos/${item.documento}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {item.documento}
                                      </a>
                                    </div>
                                  </td>
                                  <td
                                    style={{ textAlign: "center", width: "8%" }}
                                  >
                                    {item.fechaEntrega != ""
                                      ? moment(item.fechaEntrega).format(
                                          "DD-MMM-YYYY",
                                        )
                                      : ""}
                                  </td>
                                  <td
                                    style={{ textAlign: "center", width: "8%" }}
                                  >
                                    {item.proxFecha != ""
                                      ? moment(item.proxFecha).format(
                                          "DD-MMM-YYYY",
                                        )
                                      : ""}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      color:
                                        item.estatus === "SIN VALIDAR"
                                          ? "red"
                                          : "black",
                                    }}
                                  >
                                    {item.estatus === "SIN VALIDAR" ? (
                                      idNefro === 0 ? (
                                        <Tag color="red">{item.estatus}</Tag>
                                      ) : (
                                        <Button
                                          color="red"
                                          variant="outlined"
                                          size="xs"
                                          onClick={() => {
                                            openModalValida({
                                              idReq: item.idReq,
                                              documento: item.nomReq,
                                            });
                                          }}
                                        >
                                          SIN VALIDAR
                                        </Button>
                                      )
                                    ) : (
                                      item.estatus === 'VALIDADO' ? <Tag color="green">{item.estatus}</Tag> : 
                                      <Tag color="#000">{item.estatus}</Tag>
                                    )}
                                  </td>
                                  <td>
                                    <input
                                      ref={fileInputRef}
                                      type="file"
                                      key={`file-${item.idReq}`}
                                      accept={item.accept}
                                      onChange={(e) =>
                                        uploadDoc(e, {
                                          idReq: item.idReq,
                                        })
                                      }
                                    ></input>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr></tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Card>
              </Tabs.Tab>
              {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB Antecedentes */}
              <Tabs.Tab
                eventKey="3"
                title={
                  isMobile ? (
                    <FaBookMedical></FaBookMedical>
                  ) : (
                    "Historia Clínica"
                  )
                }
                disabled={disabledAnteced}
              >
                {listaAnteced.length > 0
                  ? listaAnteced.map((itm, index) => {
                      return (
                        <div key={`div-${index}`}>
                          <Accordion.Panel
                            header={`${itm.nombre}`}
                            bordered
                            defaultExpanded={false}
                            key={`accord-${index}`}
                          >
                            <Table
                              striped
                              bordered
                              hover
                              responsive
                              key={`tbl-${index}`}
                              style={{
                                width: "100%",
                                cellPadding: "5",
                                cellSpacing: "10",
                                fontSize: isMobile ? "10px" : "16px",
                              }}
                              cellPadding={10}
                              cellSpacing={10}
                            >
                              <thead key={`headers-${index}`}>
                                <tr
                                  key={`fila-${index}`}
                                  style={{
                                    borderBottom: "solid 2px",
                                    paddingBottom: "15",
                                  }}
                                >
                                  {isMobile ? (
                                    ""
                                  ) : (
                                    <th
                                      key={`header0-${index}`}
                                      style={{
                                        textAlign: "center",
                                        width: "5%",
                                      }}
                                    >
                                      <b>#</b>
                                    </th>
                                  )}
                                  <th
                                    key={`header1-${index}`}
                                    style={{ width: "30%" }}
                                  >
                                    <b>Item</b>
                                  </th>
                                  <th
                                    key={`header2-${index}`}
                                    style={{
                                      width: "15%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <b>Respuesta</b>
                                  </th>
                                  <th
                                    key={`header3-${index}`}
                                    style={{ width: "50%" }}
                                  >
                                    <b>Observaciones</b>
                                  </th>
                                </tr>
                              </thead>
                              {itm.detalles.map((item, ix) => {
                                return (
                                  <tr key={`fila-${ix}`}>
                                    {isMobile ? (
                                      ""
                                    ) : (
                                      <td
                                        key={`celda1-${ix}`}
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.id}
                                      </td>
                                    )}
                                    <td key={`celda2${index}-${ix}`}>
                                      {item.Item}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <select
                                        key={`select-${ix}`}
                                        style={{ border: "none" }}
                                      >
                                        <option
                                          key={`opt-select-SinVal-${ix}-${index}`}
                                          value=""
                                          selected={
                                            item.valorado === "" ? true : false
                                          }
                                        ></option>
                                        <option
                                          key={`opt-select-SI-${ix}-${index}`}
                                          value="SI"
                                          selected={
                                            item.valorado === "SI"
                                              ? true
                                              : false
                                          }
                                        >
                                          SI
                                        </option>
                                        <option
                                          key={`opt-select-NO-${ix}-${index}`}
                                          value="NO"
                                          selected={
                                            item.valorado === "NO"
                                              ? true
                                              : false
                                          }
                                        >
                                          NO
                                        </option>
                                      </select>
                                    </td>
                                    <td key={`obs-${index}${ix}`}>
                                      <Input
                                        value={item.observacion}
                                        defaultValue={item.observacion}
                                        style={{
                                          fontSize: isMobile ? "10px" : "16px",
                                        }}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            </Table>
                          </Accordion.Panel>
                        </div>
                      );
                    })
                  : ""}
              </Tabs.Tab>
              {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB Expediente */}
              <Tabs.Tab
                eventKey="4"
                title={isMobile ? <FaFolder></FaFolder> : "Expediente"}
                disabled={disabledExped}
              >
                <Card style={{ height: "370px", padding: "20px" }}>
                  <div className="row">
                    <div className="col">
                      <Tbl
                        height={300}
                        hover={true}
                        showHeader={true}
                        data={getDataExped}
                        sortColumn={sortColumnExped}
                        sortType={sortTypeExped}
                        onSortColumn={handleSortColumnExped}
                        loading={loadingExped}
                        bordered={true}
                        cellBordered={true}
                        headerHeight={30}
                        rowHeight={40}
                        key={`id-tbl-3`}
                        id="tbl-3"
                      >
                        <Column width={0} align="center">
                          <HeaderCell>Id</HeaderCell>
                          <Cell dataKey="idConsulta" />
                        </Column>

                        <Column width={0} align="center">
                          <HeaderCell>Id</HeaderCell>
                          <Cell dataKey="idExped" />
                        </Column>

                        <Column align="center" sortable width={340}>
                          <HeaderCell align="center">Fecha</HeaderCell>
                          <Cell dataKey="fecha" />
                        </Column>

                        <Column width={50} fixed>
                          <HeaderCell></HeaderCell>
                          <Cell style={{ padding: "6px" }} align="center">
                            {(rowData) => (
                              <Button
                                appearance="subtle"
                                size="sm"
                                onClick={() =>
                                  getDetalles({
                                    idC: rowData.idConsulta,
                                    idPac: idPac,
                                    titulo: `EXPED-${rowData.idExped}-${rowData.idConsulta} / Fecha: ${rowData.fecha}`,
                                    diagnostico: rowData.diagnostico,
                                    tratamiento: rowData.tratamiento,
                                    indicaciones: rowData.inidcaciones,
                                    observa: rowData.observa,
                                  })
                                }
                              >
                                <LucideZoomIn />
                              </Button>
                            )}
                          </Cell>
                        </Column>

                        <Column width={250} flexGrow={true}>
                          <HeaderCell>Motivo Consulta</HeaderCell>
                          <Cell dataKey="motivoConsulta" />
                        </Column>

                        <Column width={0} fixed resizable sortable>
                          <HeaderCell>Diagnostico</HeaderCell>
                          <Cell dataKey="diagnostico"></Cell>
                        </Column>

                        <Column
                          width={310}
                          fixed
                          flexGrow={true}
                          resizable
                          sortable
                        >
                          <HeaderCell>Tratamiento</HeaderCell>
                          <Cell dataKey="tratamiento" />
                        </Column>

                        <Column width={0} fixed resizable sortable>
                          <HeaderCell>Indicaciones</HeaderCell>
                          <Cell dataKey="inidcaciones" />
                        </Column>

                        <Column width={100} fixed resizable>
                          <HeaderCell align="center">Docs</HeaderCell>
                          <Cell dataKey="Docs" align="center" />
                        </Column>
                      </Tbl>
                    </div>
                  </div>
                </Card>
              </Tabs.Tab>
            </Tabs>

            {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> DRAWER EXPEDIENTE PACIENTE */}
            <Drawer size="xxl" open={open} onClose={() => setOpen(false)}>
              <Drawer.Header>
                <Drawer.Title>
                  {paciente} <br /> {tituloDrawer}
                </Drawer.Title>
              </Drawer.Header>
              <Drawer.Body>
                <Card>
                  <Card.Body>
                    <Text size={"md"} weight="bold">
                      Motivo de consulta
                    </Text>
                    {motivoEx}
                  </Card.Body>
                </Card>
                {appConfigParams.mostrarExplora === 1 ? (
                  <div className="row mb-1">
                    <div className="col">
                      <Panel
                        bordered
                        header="Exploración Física"
                        defaultExpanded
                        key="panelExploraFisExpedinete"
                      >
                        <div className="row">
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Peso</Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={pesoEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Talla</Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={tallaEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">IMC</Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={imcEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Presión arterial">
                              TA
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={presionArtEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Frec. Cardiaca">
                              FC
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={frecCardiacaEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Frec. Respiratoria">
                              FR
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={frecRespEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Temperatura">
                              <b>T</b>emperatura
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={tempEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Saturación de O2">
                              Sp<b>O</b>2
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={saturaOxEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Glicemia capilar</Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={glicemiaCapEx}
                              readOnly
                            />
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Text size="sm">Otros datos</Text>
                            <Input
                              as="textarea"
                              placeholder="Generales de la exploración..."
                              rows={3}
                              value={otrosDatosExploraEx}
                              readOnly
                            />
                          </div>
                        </div>
                      </Panel>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {dataSignosEx.length > 0 ? (
                  <div className="row mb-2">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <Card key={`card1-Ex`}>
                        <Card.Header
                          style={{ fontSize: "12px" }}
                          key={`cardHeader-1-Ex`}
                        >
                          <b>{dataSignosEx[0].nombre}</b>
                        </Card.Header>
                        <Card.Body key={`cardBody-1-Ex`}>
                          <Textarea
                            key={`gpo1-Ex`}
                            rows={4}
                            readOnly
                            value={dataSignosEx[0].items[0]}
                            onChange={(e) =>
                              handleChangeValueExplora(e, dataSignosEx[0].idGpo)
                            }
                          />
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <Card key={`card2-Ex`}>
                        <Card.Header
                          style={{ fontSize: "12px" }}
                          key={`cardHeader-2-Ex`}
                        >
                          <b>{dataSignosEx[1].nombre}</b>
                        </Card.Header>
                        <Card.Body key={`cardBody-2-Ex`}>
                          <Textarea
                            key={`gpo2-Ex`}
                            rows={4}
                            readOnly
                            value={dataSignosEx[1].items[0]}
                            onChange={(e) =>
                              handleChangeValueExplora(e, dataSignosEx[1].idGpo)
                            }
                          />
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <Card key={`card-3-Ex`}>
                        <Card.Header
                          style={{ fontSize: "12px" }}
                          key={`cardHeader-3-Ex`}
                        >
                          <b>{dataSignosEx[2].nombre}</b>
                        </Card.Header>
                        <Card.Body key={`cardBody-3-Ex`}>
                          <Textarea
                            key={`gpo3-Ex`}
                            rows={4}
                            readOnly
                            value={dataSignosEx[2].items[0]}
                            onChange={(e) =>
                              handleChangeValueExplora(e, dataSignosEx[2].idGpo)
                            }
                          />
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <Card key={`card-4-Ex`}>
                        <Card.Header
                          style={{ fontSize: "12px" }}
                          key={`cardHeader-4-Ex`}
                        >
                          <b>{dataSignosEx[3].nombre}</b>
                        </Card.Header>
                        <Card.Body key={`cardBody-4-Ex`}>
                          <Textarea
                            key={`gpo4-Ex`}
                            rows={4}
                            readOnly
                            value={dataSignosEx[3].items[0]}
                            onChange={(e) =>
                              handleChangeValueExplora(e, dataSignosEx[3].idGpo)
                            }
                          />
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="row mb-2">
                  <div className="col">
                    <List style={{ flex: 1 }} bordered>
                      <List.Item>
                        <b>Diagnostico</b>
                        <br></br> {diagnostico}
                      </List.Item>
                      <List.Item>
                        <b>Tratamiento</b>
                        <br></br> {tratamiento}
                      </List.Item>
                      <List.Item>
                        {appConfigParams.emitirReceta === 1 ? (
                          <IconButton
                            size="sm"
                            circle
                            onClick={() => setModalReceta(true)}
                            placement="left"
                            icon={<SearchIcon />}
                            appearance="ghost"
                          ></IconButton>
                        ) : (
                          ""
                        )}
                        &nbsp;
                        <b>Indicaciones</b>
                        <br></br>
                        {getFinalText(indicaciones)}
                      </List.Item>
                    </List>
                  </div>
                </div>
                <Panel header="Laboratorios y/o Estudios de Gabinete" bordered>
                  <div className="row mb-3">
                    <div className="col">
                      <Input
                        as="textarea"
                        style={{ width: "100%" }}
                        rows={2}
                        placeholder="Escriba aquí los resultados de los laboratorio o estudios..."
                        value={labsEstudiosEx}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      {imageList.length > 0 ? (
                        <Carousel
                          autoplay
                          autoplayInterval={4000}
                          shape="bar"
                          height={120}
                        >
                          {imageList.map((el, index) => {
                            if (el.tipoDoc === "File") {
                              return (
                                <div key={index}>
                                  <br></br>
                                  <ul>
                                    <a
                                      style={{ color: "white" }}
                                      href={`Images/Negocios/${idNegocio}/Expedientes/${idPac}/Consultas/${idConsulta}/${el.doc}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {el.doc}
                                    </a>
                                  </ul>
                                </div>
                              );
                            } else {
                              return (
                                <div key={index}>
                                  <a
                                    href={`Images/Negocios/${idNegocio}/Expedientes/${idPac}/Consultas/${idConsulta}/${el.doc}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <img
                                      height="200"
                                      alt="Doc o Imagen"
                                      src={`Images/Negocios/${idNegocio}/Expedientes/${idPac}/Consultas/${idConsulta}/${el.doc}`}
                                    ></img>
                                  </a>
                                </div>
                              );
                            }
                          })}
                        </Carousel>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-lg-8 col-lg-md-8 col-sm-8">
                      <b>Notas</b>
                      <Input
                        as="textarea"
                        rows={3}
                        placeholder="Anotaciones..."
                        readOnly
                        value={observaCita}
                      />
                    </div>
                  </div>
                </Panel>
              </Drawer.Body>
            </Drawer>

            {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL RECETA MÉDICA */}
            <Modal size="lg" open={modalReceta} onClose={handleClose}>
              <Modal.Header>
                <Modal.Title>Indicaciones (Receta Médica)</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <hr></hr>
                <div ref={componentRef}>
                  <div className="row">
                    <div className="col">
                      <table style={{ width: "100%" }} border={0}>
                        <tr>
                          <td style={{ width: "50%" }}>{diagnostico}</td>
                          <td>{getFinalText(indicaciones)}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <hr></hr>
              </Modal.Body>
              <Modal.Footer>
                <Button appearance="primary" onClick={handlePrint}>
                  Imprimir
                </Button>
              </Modal.Footer>
            </Modal>

            {/* *************************************************************** MODAL LISTA DE REQUISITOS **********************************  */}
            <Modal
              size="lg"
              open={modalOpenReqs}
              onClose={handleCloseModalReqs}
            >
              <Modal.Header>
                <Modal.Title>
                  Lista de documentos para nuevos pacientes
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Panel
                  bordered
                  style={{ padding: "15px" }}
                  header="Requisitos para nuevos pacientes, estos deberán adjuntarse al finalzar el alta."
                >
                  <div>
                    {listReqs.map((el) => {
                      return <li key={el.IdRequisito}>{el.NombreReq}</li>;
                    })}
                  </div>
                </Panel>
              </Modal.Body>
              <Modal.Footer>
                <Button appearance="primary" onClick={handleCloseModalReqs}>
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>

            {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL PARA VALIDAR DOCUMENTO <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
            <Modal
              size="md"
              open={modalValida}
              onClose={handleCloseModalValida}
            >
              <Modal.Header>
                <Modal.Title>Validación del documento ({nombreNefro})</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Panel bordered style={{ padding: "5px" }}>
                  <Card>
                    <div className="row">
                      <div className="col-lg-2 col-md-2 col-sm-2" style={{ textAlign: "left" }}>
                        <Text size={"sm"} weight="medium">
                          <Tag color="#c5e7fc">Documento: </Tag>
                        </Text>
                      </div>
                      <div
                        className="text-left col-lg-10 col-md-10 col-sm-10"
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          float: "left",
                        }}
                      >
                        {documentoAValidar}
                      </div>
                    </div>
                  </Card>
                  <br></br>
                  <div className="row">
                    <div className="col">
                      <Button type="primary" onClick={() => saveAuthRequisito()} block>
                        Autorizar documento
                      </Button>
                    </div>
                  </div>
                </Panel>
              </Modal.Body>
              <Modal.Footer>
                <Button appearance="primary" onClick={handleCloseModalValida}>
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        ) : (
          ""
        )}
      </LayoutHome>
    </>
  );
};

function toValueString(value, dataType) {
  return dataType === "date" ? value?.toLocaleDateString() : value;
}

const fieldMap = {
  string: Input,
  number: NumberInput,
  date: DatePicker,
  select: SelectPicker,
};

const EditableCell = ({
  rowData,
  dataType,
  dataKey,
  onChange,
  onEdit,
  ...props
}) => {
  const editing = rowData.status === "EDIT";

  const Field = fieldMap[dataType];
  const value = rowData[dataKey];
  const text = toValueString(value, dataType);

  return (
    <Cell
      {...props}
      className={editing ? "table-cell-editing" : ""}
      onDoubleClick={() => {
        onEdit?.(rowData.id);
      }}
    >
      {editing ? (
        <Field
          defaultValue={value}
          searchable={false}
          data={[
            { label: "SI", value: "SI" },
            { label: "NO", value: "NO" },
          ]}
          onChange={(value) => {
            onChange?.(rowData.id, dataKey, value);
          }}
          style={{ height: "30px", width: "99%" }}
        />
      ) : (
        text
      )}
    </Cell>
  );
};
